import type { JobViewModel } from '../../types/jobs.types';
import { trackContactUsComplete } from '../analytics/gtmEvents';
import { API_METHODS } from './api.enums';
import newAPIService from './newAPIService';
import { apiAction } from './utils.actions';

export const reportJob = (job: JobViewModel, text) => newAPIService.post('/report', {
    subject: 'דיווח על משרה',
    message: `
    title: ${job.title} 
    jobid: ${job.jobid} 
    joburl: ${window.location.href}job/details/${job.jobid} 
    current - url : ${window.location.href}
    user message: ${text}`,
});

export type ContactUsPayload = {
    fullname: string
    email: string
    phone: string
    subject: string
    message: string
    userid?: number
}
export type UserSettingsViewModel = {
    userid: number
}
export const postContactUs = async (
    payload: ContactUsPayload,
) => {
    const response = await apiAction({
        url: '/contactus',
        method: API_METHODS.POST,
        payload,
    });
    trackContactUsComplete({ userid: payload.userid });
    return response;
};
